import { ADD_COUPON, ADD_COUPON_FAILURE, ADD_COUPON_SUCCESS } from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const addCouponReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COUPON:
      return { ...state, loading: true };
    case ADD_COUPON_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ADD_COUPON_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default addCouponReducer;
